module.exports = __webpack_public_path__ + "img/客户管理.fbd5b28a.png";